module.exports = __webpack_public_path__ + "img/loader-343px-343px.47477a57.svg";